import { render, staticRenderFns } from "./approvalMediaForecasts.vue?vue&type=template&id=ce33b7e6&scoped=true&"
import script from "./approvalMediaForecasts.vue?vue&type=script&lang=js&"
export * from "./approvalMediaForecasts.vue?vue&type=script&lang=js&"
import style0 from "./approvalMediaForecasts.vue?vue&type=style&index=0&id=ce33b7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce33b7e6",
  null
  
)

export default component.exports